var path = 'event/event-header-debug-rulenode.tpl.html';
var html = " <div hide-xs hide-sm translate class=tb-cell flex=25>event.event-time</div> <div translate class=tb-cell flex=20>event.server</div> <div translate class=tb-cell flex=10>event.type</div> <div translate class=tb-cell flex=15>event.entity</div> <div translate class=tb-cell flex=20>event.message-id</div> <div translate class=tb-cell flex=20>event.message-type</div> <div translate class=tb-cell flex=15>event.relation-type</div> <div translate class=tb-cell flex=10>event.data</div> <div translate class=tb-cell flex=10>event.metadata</div> <div translate class=tb-cell flex=10>event.error</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-header-debug-rulenode.tpl.html
// module id = 1478
// module chunks = 1